import React, { CSSProperties } from 'react';

interface ISkeletonElement {
  type: string
  className?: string
  style?: CSSProperties
}

const SkeletonElement = ({
  type, className: cn = '', style,
}:ISkeletonElement) => {
  const className = `skeleton ${type} ${cn}`;

  return (
    <div className={className} style={style} />
  );
};

export default SkeletonElement;
